import Swiper from 'swiper';
import { refs, domReady, booleanDataset } from '../modules/utils.js';
import { test as testMedia } from '../modules/match-media.js';

class EditorialBox3 extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  #listeners() {
    this.refs.next?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    this.refs.prev?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });
  }

  #slider() {
    if (!this.refs.slider) return;
    const slidesCount = this.refs.slides?.length ?? 0;
    let hideNav = false;
    let initSlider = true;

    if (!testMedia('small')) {
      if (slidesCount < 2) {
        initSlider = false;
        hideNav = true;
      }
    }

    if (initSlider) {
      this.slider = new Swiper(
        this.refs.slider,
        {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true
        }
      );

      this.slider.on('slideChange', () => {
        this.dataset.index = this.slider.realIndex;
      });
    }

    // if (hideNav) {
    //   booleanDataset(this.refs.navWrapper, 'hidden', true);
    // }
  }
}

customElements.define('editorial-box-3', EditorialBox3);
